import React, { MouseEventHandler } from 'react';
import { UseFormReturn, useFormContext } from 'react-hook-form';
import { CircularProgress } from '@mui/material';
import { StyledButton } from './components/styledButton';
import { StyledIcon } from './components/styledIcon';
import { StyledLabel } from './components/styledLabel';
import { BUTTON_COLOR_DEFAULT, BUTTON_VARIANT_DEFAULT, loaderSizes } from './const';
import { BUTTON_COLOR, BUTTON_VARIANT, ButtonProps } from './model';
export type { ButtonProps } from './model';

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    children,
    square = false,
    variant: _variant = BUTTON_VARIANT_DEFAULT,
    color: _color = BUTTON_COLOR_DEFAULT,
    size = 'normal',
    loading = false,
    icon,
    iconLeft,
    iconRight: _iconRight,
    tabIndex = 0,
    type = 'button',
    labelSx,
    onClick,
    ...buttonTagProps
  } = props;

  let form: UseFormReturn | undefined;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    form = useFormContext();
  } catch {
    // If we are not inside form, just do nothing
  }

  const variant = BUTTON_VARIANT.includes(_variant) ? _variant : BUTTON_VARIANT_DEFAULT;
  const color = BUTTON_COLOR.includes(_color) ? _color : BUTTON_COLOR_DEFAULT;
  const iconRight = _iconRight ?? icon;
  const ownerState = {
    square,
    variant,
    color,
    disabled: loading || (buttonTagProps.disabled ?? false) || (type === 'submit' && Boolean(form?.formState.isSubmitting)),
    size,
    loading,
    iconLeft,
    iconRight,
  };

  const handleClick: MouseEventHandler<HTMLButtonElement> = (...args) => {
    if (ownerState.disabled) {
      return;
    }

    onClick?.(...args);
  };

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <StyledButton onClick={handleClick} ownerState={ownerState} ref={ref as any} tabIndex={tabIndex} type={type} {...buttonTagProps}>
      {!square && iconLeft && <StyledIcon ownerState={ownerState}>{iconLeft}</StyledIcon>}
      <StyledLabel ownerState={ownerState} sx={labelSx}>
        {children}
        {loading && <CircularProgress color="inherit" size={loaderSizes[size]} />}
      </StyledLabel>
      {!square && iconRight && <StyledIcon ownerState={ownerState}>{iconRight}</StyledIcon>}
    </StyledButton>
  );
});
